import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { Container } from 'components/basics';
import { breakpoints } from 'styles/breakpoints';
import { breakpoint } from 'utils/mediaQueries';
import TeamBlock from './TeamBlock';
import TextTeam from './TextTeam';

const ContentBlock = styled(Grid)`
  margin: 0;
  width: 100%;
  position: relative;
  height: ${props => `${props.heightteam}px`};
  overflow: hidden;
  ${breakpoint.down('md')`
  height: auto !important`}
`;
const StyledTypography = styled(Typography)`
  height: 12rem;
  font-family: ${props => `${props.theme.typography.h2.fontFamily}`};
  ${breakpoint.down('md')`
    font-size: ${props =>
      `${props.theme.typography.body1.fontSize}px`}; height: auto;
  `}
`;
class TeamBlocks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      heightTeamBlock: 0,
      heighttypoTeam: 0,
      heighttextTeam: 0,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  updateDimensions() {
    const heightTeam = document.getElementById('teamBlock');
    const heightgrid = document.getElementById('typoTeam');
    const heightText = document.getElementById('textTeam');
    this.setState({
      width: window.innerWidth,
      heightTeamBlock: heightTeam && heightTeam.clientHeight,
      heighttypoTeam: heightgrid && heightgrid.clientHeight,
      heighttextTeam: heightText && heightText.offsetHeight,
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const heightTeam = document.getElementById('teamBlock');
    const heightgrid = document.getElementById('typoTeam');
    const heightText = document.getElementById('textTeam');
    if (
      heightTeam &&
      prevState.heightTeamBlock !== this.state.heightTeamBlock
    ) {
      this.setState({
        heightTeamBlock: heightTeam && heightTeam.clientHeight,
        heighttypoTeam: heightgrid && heightgrid.clientHeight,
        heighttextTeam: heightText && heightText.offsetHeight,
      });
    }
  }
  render() {
    const widthWindow = this.state.width;
    const heightTeam = this.state.heightTeamBlock + this.state.heighttypoTeam;
    const isMobile = widthWindow < `${breakpoints.values.md}`;
    return (
      <Container>
        <ContentBlock
          container
          spacing={40}
          justify="center"
          heightteam={heightTeam}
        >
          <StyledTypography variant={'h5'} id="typoTeam">
            {this.props.data.markdownContent.frontmatter.title}
          </StyledTypography>
          <TeamBlock images={this.props.data.images} isMobile={isMobile} />
          <TextTeam
            data={this.props.data.markdownContent}
            lang={this.props.lang}
          />
        </ContentBlock>
      </Container>
    );
  }
}

export default TeamBlocks;
